import type { PaginatedList } from '../../stores/common/padinated-list';
import {
  toQueryString,
  type PaginationQueryParamsWithStatus
} from '../../stores/common/pagination-query-params';
import { makeGet, makePatch, makePost } from '../../utils/call-api-endpoint';
import type { Envelope } from '../../utils/envelope';
import type { Usuario } from './usuario';

export async function obtenerUsuariosPaginados(
  params: PaginationQueryParamsWithStatus
): Promise<Envelope<PaginatedList<Usuario>>> {
  const response = await makeGet<PaginatedList<Usuario>>(
    `/usuarios/paginados?${toQueryString(params)}`
  );
  return response;
}

export async function obtenerUsuarioPorId(id: string): Promise<Envelope<Usuario>> {
  const response = await makeGet<Usuario>(`/usuarios/${id}`);
  return response;
}

export interface RegistrarUsuarioRequest {
  id: string;
  idPerfil: number;
  nombre: string;
  password: string;
}

export async function registrarUsuario(
  request: RegistrarUsuarioRequest
): Promise<Envelope<string>> {
  const response = await makePost<RegistrarUsuarioRequest, string>('/usuarios', request);
  return response;
}

export interface ActualizarUsuarioRequest {
  idPerfil: number;
  nombre: string;
  actualizarPassword: boolean;
  password?: string;
}

export async function actualizarUsuario(
  id: string,
  request: ActualizarUsuarioRequest
): Promise<Envelope<void>> {
  const response = await makePatch<ActualizarUsuarioRequest, void>(`/usuarios/${id}`, request);
  return response;
}

export async function desactivarUsuario(id: string): Promise<Envelope<unknown>> {
  const response = await makePatch(`/usuarios/${id}/desactivar`);
  return response;
}
